import styled from 'styled-components';
import {hexToRGBA} from "../social-profile/social-profile.style";
import {themeGet} from "@styled-system/theme-get";
import {Color} from "./animals";

export const StyledCommentSection = styled.div`
    padding-bottom: 30px;
    hr {
        margin-top: 12px;
        border: none;
        height: 1px;
        background-color:  black;
    }
`

export const StyledCustomizer = styled.div`
    position: absolute;
    padding: 0.5em;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.semiforeground};
    z-index: 1;
    left: 26px;
    // position top
    //top: calc(-1 * (6 * 40px + 5 * 10px + 2 * 0.5em + 3 * 16px + 8px));
    top: 1em;
    width: calc(6 * 40px + 5 * 10px + 2 * 1em);
    user-select: none;
    background-color: ${({ theme }) => theme.body};
    box-shadow: 0 0 10px ${({ theme }) => theme.shadow};
    
    div.icon-grid {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(6, 1fr);
        div {
            background-color: ${({ theme }) => theme.semibackground};
            border-radius: 40%;
            width: 40px;
        }
        img {
            width: 100%;
        }
        div:hover {
            background-color: #ddd;
        }
    }
    
    div.color-grid {
        margin-top: 1em;
        display: grid;
        gap: 3px;
        grid-template-columns: repeat(12, 1fr);
        div {
            border-radius: 40%;
            width: 22px;
            height: 22px;
            border: 1px solid ${({ theme }) => theme.semibackground};
        }
        div:hover {
            border: 1px solid ${({ theme }) => theme.text};
        }
    }
`

export const StyledCustomizeOverlay = styled.div`
    display: flex;
    position: absolute;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    top: 0;
    height: 100%;
    width: 100%;
    font-size: 2em;
    svg {
        display: none;
    }
    &:hover { 
        background-color: ${({theme}) => hexToRGBA(theme.body, 0.5)};
        svg {
            display: block;
        }
    }
`
export const StyledIconTile = styled.div<{ size: number, color: Color, isAdmin: boolean}>`
    border-radius: 40%;
    background-color: ${({ theme, isAdmin, color }) => isAdmin ? theme.semibackground : color};
    border: 1px solid ${({ theme }) => theme.semibackground};
    img {
        width: 100%;
        height: 100%;
        padding: 10%;
    }
    width: calc(64px * ${({ size }) => size});
    height: calc(64px * ${({ size }) => size});
    position: relative;
    @media (max-width: 600px) {
        width: calc(48px * ${({ size }) => size});
        height: calc(48px * ${({ size }) => size});
    }
    margin-right: .5em;
`

export const MarkdownStyledComment = styled.div`
    div {
        white-space: initial;
        word-wrap: break-word;
    }
    
    span.pre, div.code {
        background-color: ${({ theme }) => theme.semibackground};
        border-radius: 5px;
        font-family: monospace;
    }

    span.pre {
        padding: 0.2em 0.4em; 
    }
    
    div.code {
        background-color: ${({ theme }) => theme.semibackground};
        padding: 1em;
        margin-top: 1em
    }
    
    svg.link-like {
        color: blue;
        cursor: pointer;
        height: .7em;
        transform: translateY(-.2em);
    }
    
    a {
        color: blue;
    }
    ul {
        padding-left: 20px;
        margin-top: 0.3em;
    }
`

export const ErrorMessage = styled.p`
  color: red;
  margin-top: 2px;
  margin-bottom: 0;
  font-size: ${themeGet('fontSizes.2', '12')}px;
  &.placeholder {
     visibility: hidden; 
     &::after {
         content: '.';
     }
  }
`;


export const StyledCommentContent = styled.form<{isCollapsed: boolean, showMd: boolean}>`
    width: calc(100% - 64px - 1em);
    @media (max-width: 600px) {
        width: calc(100% - 32px);
    }
    @media (max-width: 400px) {
        font-size: 0.9em;
    }
    
    input, textarea {
        border: none;
        color: ${({ theme }) => theme.text};
        background-color: ${({ theme }) => theme.body};
        resize: none;
        border-bottom: 2px solid ${({ theme }) => theme.body};
        font-size: 16px;
        @media (max-width: 400px) {
            font-size: 0.9em;
        }
    }   
    input {
        font-weight: bold;
        width: 100%;
    }
    
    input::placeholder {
        color: ${({ theme }) => theme.text};
    }
    
    input:focus, textarea:focus {
        outline: none;
        border-bottom: 2px solid ${({ theme }) => theme.text};
    }
    
    div.column-container {
        @media (min-width: 800px) {
            display: grid;
            gap: 1em;
        }
        grid-template-columns: 1fr ${({showMd}) => showMd ? '1fr' : ''};
        div, textarea {
            width: 100%;
            border: 3px solid ${({ theme }) => theme.semibackground};
            padding: 5px;
            border-radius: 5px;
        }
        div {
            user-select: none;
            cursor: not-allowed;
        }
    }
    div.comment-head {
        display: flex;
        justify-content: space-between;
        span.author {
            font-weight: bold;
            margin-right: 1em;
        }
        span.date {
            font-size: 0.9em;
            @media (max-width: 400px) {
                font-size: 0.81em;
            }
        }
    }
        svg {
            transform: translateY(.15em);
        }
    }

    div.comment-body {
        display: ${({ isCollapsed }) => (isCollapsed ? 'none' : 'block')};
        svg.markdown-icon {
            color: ${({ theme, showMd }) => showMd ? theme.text : '#aaa'};
            position: absolute;
            top: 25px;
            right: 16px;
            @media (max-width: 600px) {
                right: 8px;
            }
            @media (max-width: 400px) {
                top: 21px;
                right: 6px;
            }
        }
        @media (hover: hover) {
            svg:hover {
                color: blue;
            }
        }
    }
    
    button {
        width: 100px;
        height: 30px;
        margin: 0 10px 10px 0;
        font-size: 1em;
        @media (max-width: 400px) {
            width: 85px;
            font-size: 0.9em;
        }
        background-color: ${({theme}) => theme.semiforeground};
        color: ${({theme}) => theme.body};
        cursor: pointer;
        border: none;
        border-radius: 6px;
        font-weight: bold;

        &:active {
            transition: transform .1s ease-in;
            transform: scale(0.95);
        }
    }
`

export const StyledCommentContainer = styled.div`
    position: relative;
`
export const StyledComment = styled.div<{ depth: number, hide?: boolean}>`
    //background-color: ${({ theme }) => theme.semibackground};
    //padding: .5em;
    margin-left: ${({depth}) => 2 * depth}em;

    @media (max-width: 600px) {
        margin-left: ${({depth}) => 1 * depth}em;
        
    }
    margin-top: ${({depth}) => !depth ? '2' : '0'}em;;
    //border-left: 1px solid ${({ theme }) => theme.semiforeground};
    display: flex;
`